// API Utility Functions
// Helper functions for file handling and validation

import { formatNumber } from '../../utils/numberFormat';

/**
 * Check if file upload is supported by the browser
 * @returns {boolean} True if supported
 */
export const supportsFileUpload = () => {
  return window.File && window.FileReader && window.FormData;
};

/**
 * Validate OCEL file format
 * @param {File} file - The file to validate
 * @returns {Promise<boolean>} True if valid
 */
export const validateOCELFile = (file) => {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('No file provided'));
      return;
    }
    if (!file.name.toLowerCase().endsWith('.json')) {
      reject(new Error('File must be a JSON file'));
      return;
    }
    resolve(true);
  });
};

/**
 * Format file size for display
 * @param {number} bytes - File size in bytes
 * @returns {string} Formatted file size
 */
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  // Unit symbols are identical in German, so they are deliberately not translated.
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  // The number itself DOES follow the UI language: string concatenation of a raw
  // number always emits an English decimal point ("1.5 MB") regardless of locale.
  // formatNumber's minimumFractionDigits:0 reproduces the previous parseFloat
  // trailing-zero trimming.
  return formatNumber(bytes / Math.pow(k, i), { decimals: 2 }) + ' ' + sizes[i];
};
